type BuildCompletionRedirectUrlParams = {
  redirectUrl: string;
  currentUrl: string;
};

export function buildCompletionRedirectUrl({
  redirectUrl,
  currentUrl
}: BuildCompletionRedirectUrlParams) {
  if (!redirectUrl) return redirectUrl;

  try {
    const url = new URL(redirectUrl, currentUrl);
    url.searchParams.set('returnUrl', currentUrl);
    return url.toString();
  } catch {
    return redirectUrl;
  }
}
